import { createUseStyles } from "react-jss";
import { entitySharedStyles } from "../styles";

export const useStyles = createUseStyles({
	...entitySharedStyles
});
